import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from "@angular/common";
import { NgModule, APP_INITIALIZER, Injector } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RootRoutingModule } from './root-routing.module';
import { RootComponent } from './root.component';
import { ConfigurationService } from '@shared/services/configuration.service';
import { LocalStoreManager } from '@shared/services/local-store-manager.service';
import { AuthGuardService } from '@shared/services/authguard.service';
import { SecurityEndpoint } from '@shared/services/SecurityEndpoint.service';
import { SecurityService } from '@shared/services/security.service';
import { RegulatoryItemService } from '@shared/services/regulatoryitem.service';
import { RegulatoryItemEndpoint } from '@shared/services/regulatoryitemendpoint.service';
import { DepartmentService } from '@shared/services/department.service';
import { DepartmentEndpoint } from '@shared/services/departmentEndPoint.service';
import { UserAccessService } from '@shared/services/userAccess.service';
import { UserAccessEndpoint } from '@shared/services/userAccessEndpoint.service';
import { ReportService } from '@shared/services/report.service';
import { ReportEndpoint } from '@shared/services/reportendpoint.service';
import { EndpointFactory } from '@shared/services/endpoint-factory.service';
import { AlertService, MessageSeverity } from '@shared/services/alert.service';

////import { LoginFormModule, ChangePasswordModule, MessageHandlerModule, FooterModule } from '@app/shared/components';

import { SharedModule } from '@shared/shared.module';
import { ServiceProxyModule } from '@shared/services/service-proxy.module';


const appInitializerFn = (appConfig: ConfigurationService) => {
  return () => {
    //localStorage.clear();
    return appConfig.loadConfig();
  };
};

@NgModule({
  declarations: [
    RootComponent
  ],

  imports: [
    BrowserModule,
    CommonModule,
    SharedModule.forRoot(),
    HttpClientModule,
    RootRoutingModule,
    ServiceProxyModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [ConfigurationService]
    }
  ],
 
  bootstrap: [RootComponent]
})
export class RootModule {
}
